import { render, staticRenderFns } from "./EditPageInfo.vue?vue&type=template&id=0ca3b712&"
import script from "./EditPageInfo.vue?vue&type=script&lang=js&"
export * from "./EditPageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports